// © 2015-2021 WDNA - All Rights Reserved

import { RedirectProps, RouteProps } from 'react-router';

import Parameters from './loaders/Parameters';
import TypeSensors from './loaders/TypeSensors';
import Variables from './loaders/Variables';

export const redirects: RedirectProps[] = [
  {
    from: '/configuration',
    to: '/configuration/parameters',
  },
];

export const routes: RouteProps[] = [
  {
    component: TypeSensors,
    path: '/configuration/type/sensors',
  },
  {
    component: Parameters,
    path: '/configuration/parameters',
  },
  {
    component: Variables,
    path: '/sensors/variables',
  },
];
